module.exports = "<div class=modal-body-inner> <div class=q-pad-horz-xl> <div class=q-marg-vert-md> Your saved Inbound Shipping Quote will be removed because the shipment information changed. You can request a new quote on the Shipping tab. </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/common/quotesInvalidationFactory/html/modalBody.html
// module id = 1234
// module chunks = 1